import Krc from './Krc'

/**
 * 酷狗逐字歌词
 */
export default class KrcRoma extends Krc {
  constructor(type = 'lyricKugouRoma') {
    super(type)

    this.nameExt = '_roma_krc'
  }
}
